import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBTableBody, MDBTable, MDBTableHead, } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Descriptions   } from 'antd';
import { api, URL } from '../../api';


export default class ModelcuDescriptionshort extends Component {
    constructor(props) {
              super(props);
      this.state = {
        modal: false,
        Curriculumopen_ID :'',
        Course_ID :'',
        Course_YEAR :'',
        Curriculumopen_TEAM :'',
        Curriculumopen_Full_Name_TH:'',
        Curriculumopen_Full_Name_EN:'',
        Curriculumopen_Detail_TH:'',
        Curriculumopen_Detail_EN:'',
        Curriculumopen_CH:'',
        Curriculumopen_NUM:'',
        Curriculumopen_Date_START:'',
        Curriculumopen_Date_END:'',
        Univ_ID:'',

        Shortcourse_ID:'',
        Shortcoursemd_Course_ID:'',
        Shortcoursemd_Nameshort_TH:'',
        Shortcoursemd_Nameshort_EN:'',
        Shortcoursemd_Numch:'',
        Shortcoursemd_Numregis:'',
        Shortcoursemd_Timestart:'',
        Shortcoursemd_Timeend:'',
        Shortcoursemd_Univ_id:'',

        plan:[],

        
      }

this.getplan = this.getplan.bind(this);

}


toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }


  getplan() {
    setTimeout(() => {
       //ภายใน
       api.get('index/searchplanshortcu/'+this.props.Shortcourse_ID+'/'+this.props.Shortcoursemd_ID)
       .then(res => {
         console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
         this.setState({ plan: res.data})
       }) 
     }, 0);
  }

  componentDidMount() {

    //const { id_send } = this.props.id_send
    //console.log(this.props.Curriculumopen_ID);
    this.setState({ Shortcoursemd_ID:this.props.Shortcoursemd_ID}) 
   
  
    api.get('index/getCurriculumdetalshortmd/'+this.props.Shortcoursemd_ID,
    //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
      //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
              {headers: {
              // Authorization: 'Bearer ' + localStorage.getItem('myData')
              }
              })
             
              .then(res => {
              // console.log(res.data[0].id)
            
              this.setState({ Shortcourse_ID : res.data[0].Shortcourse_ID });
              this.setState({ Shortcoursemd_Course_ID : res.data[0].Shortcoursemd_Course_ID });
              this.setState({ Shortcoursemd_Nameshort_TH : res.data[0].Shortcoursemd_Nameshort_TH });
              this.setState({ Shortcoursemd_Nameshort_EN : res.data[0].Shortcoursemd_Nameshort_EN });
              this.setState({ Shortcoursemd_Numch : res.data[0].Shortcoursemd_Numch });
              this.setState({ Shortcoursemd_Numregis : res.data[0].Shortcoursemd_Numregis });
              this.setState({ Shortcoursemd_Timestart : res.data[0].Shortcoursemd_Timestart });
              this.setState({ Shortcoursemd_Timeend : res.data[0].Shortcoursemd_Timeend });
              this.setState({ Shortcoursemd_Univ_id : res.data[0].Shortcoursemd_Univ_id });

            
              //    const Curriculumopen = res.data;
               //   this.setState({ Curriculumopen });
       }) 
       this.getplan();
    }
  

    render() {
        return (
            <>
               
                    <MDBBtn onClick={this.toggle} color="secondary" >รายละเอียดหลักสูตรระยะสั้น</MDBBtn>
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
                        <MDBModalHeader toggle={this.toggle}>รายละเอียดหลักสูตรระยะสั้น</MDBModalHeader>
                        <MDBModalBody>
                                <Descriptions title="ข้อมูลหลักสูตรระยะสั้น" layout="vertical" bordered>
                                    <Descriptions.Item label="ชื่อภาษาไทย">{this.state.Shortcoursemd_Nameshort_TH}</Descriptions.Item>
                                    <Descriptions.Item label="ชื่อภาษาอังกฤษ">{this.state.Shortcoursemd_Nameshort_EN}</Descriptions.Item>
                                    {/* <Descriptions.Item label="หลักสูตรปี">{this.state.Course_YEAR}</Descriptions.Item> */}
                                    {/* <Descriptions.Item label="คำอธิบายรายวิชา TH">{this.state.Curriculumopen_Detail_TH === null  ? <>-</>:<>{this.state.Curriculumopen_Detail_TH}</>}</Descriptions.Item>
                                    <Descriptions.Item label="คำอธิบายรายวิชา EN">{this.state.Curriculumopen_Detail_EN === null  ? <>-</>:<>{this.state.Curriculumopen_Detail_EN}</>}</Descriptions.Item> */}
                                    <Descriptions.Item label="จำนวนชั่วโมง">{this.state.Shortcoursemd_Numch} ชั่วโมง</Descriptions.Item>
                                    {/* <Descriptions.Item label="Usage Time" span={2}>
                                    2019-04-24 18:00:00
                                    </Descriptions.Item> */}
                                    {/* <Descriptions.Item label="Status" span={3}>
                                    <Badge status="processing" text="Running" />
                                    </Descriptions.Item> */}
                                    <Descriptions.Item label="วันที่เริ่ม">{this.state.Shortcoursemd_Timestart}</Descriptions.Item>
                                    <Descriptions.Item label="วันที่สิ้นสุด">{this.state.Shortcoursemd_Timeend}</Descriptions.Item>
                                    <Descriptions.Item label="จำนวนที่รับ">{this.state.Shortcoursemd_Numregis} คน</Descriptions.Item>
                                  
                                </Descriptions>
                                <br/>
                                <p className="font-weight-bold">แผนการสอนสูตรระยะสั้น</p>  


                                <MDBTable small responsiveMd>
                                <MDBTableHead>
                                    <tr>
                                    <th>#</th>
                                    <th>สัปดาห์ที่</th>
                                    <th>หัวข้อ/รายละเอียด</th>
                                    <th>จำนวนชั่วโมง</th>
                                    <th>กิจกรรม</th>
                                    <th>ผู้สอน/วิทยากร</th>
                                    
                                    </tr>
                                </MDBTableHead>

                                <MDBTableBody>
                                {this.state.plan.map((plan,index) => {
                                  return  <tr>
                                    <td>{index+1}</td>
                                    <td>{plan.Planshort_Week }</td>
                                    <td>{plan.Planshort_Title }</td>
                                    <td>{plan.Planshort_Ch }</td>
                                    <td>{plan.Planshort_Activity }</td>
                                    <td>{plan.Teacher_NAME } {plan.Teacher_LASTNAME }</td>
                                   
                                   
                                    </tr>
                                   })}  
                                </MDBTableBody>
                            </MDBTable>      




                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                        </MDBModalFooter>
                    </MDBModal>
               
            </>
        )
    }
}
